import { createContext } from "react";

const DateRangeContext = createContext({
  dateRange: null,
  setDateRange: () => {},
});

export default DateRangeContext;
